// PPS progress statuses and BCS progress status have different IDs
// This must match the dbo.Entity table ID

// PPS Progress Statuses
export enum ProgressStatuses{
  Ongoing = 19,
  Pending = 20,
  IRCSigned = 21, 
  Invoiced = 22,
  Completed = 23, 
  Paid = 24,
  InPrep = 58
}

// BCS Progress Statuses
// export enum ProgressStatuses{
//   Ongoing = 11,
//   Pending = 12,
//   IRCSigned = 13, 
//   Invoiced = 14,
//   Completed = 15, 
//   Paid = 16,
//   InPrep = 17
// }